import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip, {
  defaultHtml: false,
});
